import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import NewOrdersIcon from "../../../../../Assets/Icons/today-new-orders.png";
import CompletedOrdersIcon from "../../../../../Assets/Icons/today-completed-orders.png";
import OrdersOnHoldIcon from "../../../../../Assets/Icons/orders-on-hold.png";
import PriorityOrdersIcon from "../../../../../Assets/Icons/today-priority-orders.png";
import PickersAttendanceIcon from "../../../../../Assets/Icons/calendar-check.png";
import httpclient from "../../../../../Utils";
import { useNotification } from "../../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../../Hooks/useApiErrorHandler";

const StatsCard = styled(Paper)(({ theme, id }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  border: "1px solid #A2A1A833",
  borderRadius: "10px",
  backgroundColor: id === 3 ? "#F45B6908" : "transparent",
}));

const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

// Sample data
const statsData = [
  {
    id: 1,
    title: "Today's New Orders",
    count: 56,
    icon: NewOrdersIcon,
    update: "Update: March 16, 2025 | 10:30 AM",
  },
  {
    id: 2,
    title: "Today's Completed Orders",
    count: 5,
    icon: CompletedOrdersIcon,
    update: "Update: March 16, 2025 | 9:57 AM",
  },
  {
    id: 3,
    title: "Orders on Hold",
    count: 2,
    icon: OrdersOnHoldIcon,
    update: "Update: March 16, 2025 | 9:57 AM",
  },
  {
    id: 4,
    title: "Today's Priority Orders",
    count: 11,
    icon: PriorityOrdersIcon,
    update: "Update: March 16, 2025 | 9:30 AM",
  },
  {
    id: 5,
    title: "Today's Pickers Attendance",
    count: {
      present: 12,
      total: 15,
    },
    icon: PickersAttendanceIcon,
    update: "Update: March 16, 2025 | 9:00 AM",
  },
];

const OrdersOverview = () => {
  const [overviewStats, setOverviewStats] = useState([]);
  const [loading, setLoading] = useState(false);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const fetchOverviewStats = async () => {
    const API_URL = "getPlugins.php";

    try {
      const res = await httpclient.get(API_URL);

      const { data } = res;

      if (data.status === 200) {
        setOverviewStats(data.data);
      } else {
        showNotification("error", data.msg);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchOverviewStats();
  }, []);

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      {statsData.map((stat) => (
        <Grid item xs={12} sm={6} md={4} lg={2.4} key={stat.id}>
          <StatsCard elevation={0} id={stat.id}>
            <Box sx={{ padding: "16px" }}>
              <CardHeader>
                <img src={stat.icon} alt={stat.title} width={24} height={24} />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 300,
                    color: "#16151C",
                    marginLeft: "16px",
                  }}
                >
                  {stat.title}
                </Typography>
              </CardHeader>
              <Box sx={{ display: "flex" }}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{ fontSize: "24px", color: "#16151C" }}
                >
                  {stat.id === 5 ? stat.count.present : stat.count}{" "}
                  {stat.id === 5 && (
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ fontSize: "14px", color: "#BFBFBF" }}
                    >
                      /{stat.count.total}
                    </Typography>
                  )}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ borderTop: "1px solid #A2A1A833", padding: "8px 16px" }}>
              <Typography
                variant="caption"
                sx={{
                  color: stat.id === 3 ? "#273B4A" : "#A2A1A8",
                  fontWeight: 300,
                }}
              >
                {stat.update}
              </Typography>
            </Box>
          </StatsCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default OrdersOverview;
